<div class="flex flex-1 flex-col">
  @if (!breadcrumbStore.hidden()) {
    <aura-breadcrumb-navigation />
  }
  <router-outlet></router-outlet>
</div>
